module.exports = __webpack_public_path__ + "static/family-business-82c042c21a7eb475ce112a052e0a6278.png";